import React from "react";
import { useNavigate } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import { useQuery } from "@tanstack/react-query";
import parse from "html-react-parser";

import { useApi } from "../../../hooks/api/useApi";
import { ART, ARTIST, CMS } from "../../../constants/api-constants";
import { useThemeChange } from "../../../utils/themeChange";

import FeaturedArt from "./FeaturedArt";
import ArtSection from "../Art/list";
import ArtistSection from "../Artist/list";

const { TEMPLATES } = CMS;
const { LIST_FEATURED_ARTS } = ART;
const { LIST_FEATURED_ARTISTS } = ARTIST;

const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.sticky.white {
    background: #212428;
    border-bottom: 0;
    box-shadow: 0 4px 20px 0 rgba(10,10,10, .8);
  }
  header#myHeader.navbar .search #quick_search{
    color: #fff;
    background: rgba(255, 255, 255, .1);
  }
  header#myHeader.navbar.white .btn, .navbar.white a, .navbar.sticky.white a{
    color: #fff;
  }
  header#myHeader .dropdown-toggle::after{
    color: #fff;
  }
  header#myHeader .logo .d-block{
    display: none !important;
  }
  header#myHeader .logo .d-none{
    display: none !important;
  }
  header#myHeader .logo .d-3{
    display: block !important;
  }
  .jumbotron.no-bg{
    background: center bottom;
    background-size: cover;
  }
  footer.footer-light .subfooter span img.d-1{
    display: none !important;
  }
  footer.footer-light .subfooter span img.d-3{
    display: inline-block !important;
  }
  .de_countdown{
    right: 10px;
    color: #fff;
  }
  .author_list_pp{
    margin-left:0;
  }
  footer.footer-light .subfooter{
    border-top: 1px solid rgba(255,255,255,.1);
  }
`;
const Home = () => {
  const navigate = useNavigate();
  const themeChange = useThemeChange();
  const { getAll, getById } = useApi();

  const homeContent = useQuery({
    queryKey: ["home"],
    queryFn: () => getById("HOME", TEMPLATES),
  });

  if (homeContent.isSuccess && homeContent?.data) {
    const home_content = JSON.parse(homeContent?.data?.data);
    var content = parse(home_content?.home_page);
  }

  const featuredArts = useQuery({
    queryKey: ["arts"],
    queryFn: () => getAll(LIST_FEATURED_ARTS),
  });

  const featuredArtists = useQuery({
    queryKey: ["artists"],
    queryFn: () => getAll(LIST_FEATURED_ARTISTS),
  });

  return (
    <div className={themeChange.add("section")}>
      <GlobalStyles />
      <section
        className="jumbotron no-bg"
        style={{
          paddingBottom: "0px",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 px-0">
              <FeaturedArt arts={featuredArts?.data} />
            </div>
            <div className="col-lg-6">{content && content}</div>
          </div>
        </div>
      </section>
      <section className="container">
        <div className="row">
          <div className="col-lg-12">
            <h2 className="style-2">License Opportunities</h2>
          </div>
        </div>
        <div className="container no-top">
          <div className="row">
            <div className="col-lg-12 px-0">
              <ArtSection
                arts={featuredArts?.data}
                loading={featuredArts?.isLoading}
              />
              <div className="d-flex justify-content-end">
                <span
                  onClick={() => navigate("/explore-license")}
                  className="btn-main lead"
                >
                  Explore Licenses Opportunities
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="container no-top">
        <div className="row">
          <div className="col-lg-12">
            <h2 className="style-2">Artists</h2>
          </div>
          <div className="col-lg-12">
            <ArtistSection allArtists={featuredArtists?.data} />
            <div className="d-flex justify-content-end">
              <span
                onClick={() => navigate("/explore-artists")}
                className="btn-main lead"
              >
                Explore Artists
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default Home;
